/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useRef, useState } from "react"
import { ReactZoomPanPinchRef, TransformComponent, TransformWrapper } from "react-zoom-pan-pinch"
import { DataContentContent, defaultPosition, LANDING_TYPE_CONTENT, ZoomPanPinchContent } from "src/modules/pe-landing-module/data/interfaces"
import "../../../assets/css/zoomPan.scss"
import { IPrimitiveProps } from "../section/Primitive"
import DataContentPrimitive from "./DataContentPrimitive"

/* Protopia Ecosystem component */ 
const ZoomPanPinchPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: ZoomPanPinchContent = ( props.primitive || {} ) as ZoomPanPinchContent 
    return !!primitive.incut
        ?
        <ZPP {...props} />
        :
        <></> 
}
export default ZoomPanPinchPrimitive

const ZPP = ( props: IPrimitiveProps ): JSX.Element => {
    const primitive: ZoomPanPinchContent = ( props.primitive || {} ) as ZoomPanPinchContent 
    const { maxScale, minScale, style } = primitive
    const { width, height, rotate, opacity } = { ...defaultPosition(), ...primitive.position }
    const ref = useRef(null)
    const [isMenu, setIsMenu] = useState<boolean>(false)
    let scale = 1
    
    const dataPrimitive: DataContentContent = useMemo<DataContentContent>(
        () => {
            return { 
                data: primitive.incut || [], 
                id: primitive.id, 
                title: "", 
                position: {
                    width:      width || 930,
                    height:     height || 930,
                    rotate:     rotate,
                    opacity:    opacity,
                },
                type: LANDING_TYPE_CONTENT.DATA_CONTENT,
                "data-primitive-type": LANDING_TYPE_CONTENT.DATA_CONTENT
            } as DataContentContent
        },
        []
    )
    const onZoomStop =  ( ref: ReactZoomPanPinchRef ) => { 
        scale = ( ref?.state.scale ) 
    }
    return <div
        className="landing-zoom-pan-pinch-cont "
        style={{ ...style, width, height }} 
        ref={ ref }
        onMouseEnter={() => setIsMenu( true )}
        onMouseLeave={() => setIsMenu( false )}
        data-primitive-type={ LANDING_TYPE_CONTENT.ZOOM_PANCH_PINCH }
    >
        <div className=" landing-zoom-pan-pinch " style={{ width, height}}>
            <TransformWrapper
                initialScale={ 1 }
                initialPositionX={ 0 }
                initialPositionY={ 0 }
                maxScale={ maxScale || 3 }
                minScale={ minScale || .5 }
                doubleClick={{
                    disabled: false,
                    mode: "reset"
                }}  
                onTransformed={ onZoomStop }
            >
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                        <div 
                            className="w-100 h-100 overflow-hidden" 
                            onClick={ () => zoomIn( undefined,undefined,"easeOutQuad" ) } 
                        >
                            <TransformComponent>
                                {/* <DataComponents section={ section } data={ section.data } /> */}
                                <DataContentPrimitive
                                    primitive={ dataPrimitive }
                                />
                            </TransformComponent>
                        </div>
                        <ZoomPanel 
                            zoomIn={ zoomIn }  
                            zoomOut={ zoomOut } 
                            resetTransform={ resetTransform } 
                            isMenu={ isMenu } 
                            minScale={ minScale }
                            maxScale={ maxScale }
                            scale={ scale }
                        />
                    </>
                )}
            </TransformWrapper>
        </div> 
    </div>
}

interface IZoomPanelProps {
    zoomIn: () => void
    zoomOut: () => void
    resetTransform: () => void
    isMenu: boolean
    maxScale: number
    minScale: number
    scale: number
}
const ZoomPanel = ({zoomIn, zoomOut, resetTransform, isMenu, minScale, maxScale, scale} : IZoomPanelProps) : JSX.Element => {
    return isMenu 
    ?
    <div className="tools"> 
        <button onClick={ () => zoomIn() } >
            <i className={`fas fa-search-plus fa-2x`} />
        </button>
        <button onClick={ () => zoomOut() } >
            <i className={`fas fa-search-minus fa-2x`} />
        </button>
        <button onClick={ () => resetTransform() } >
            <i className={`fas fa-times fa-2x`} />
        </button>
    </div>
    :
    <></>
}